import classNames from 'classnames';
import React, { Suspense } from 'react';
import { LazyDatePicker } from '../../../../../common/LazyDatePicker';

interface Props {
  title: string;
  isDisabled?: boolean;
  placeholder?: string;
  // Time to display
  time?: Date;
  // Date ranges
  startDate?: Date;
  endDate?: Date;
  error?: boolean;
  onTimeChange: (time: Date) => void;
}

const DatePicker: React.FC<Props> = ({
  title,
  time,
  isDisabled = false,
  placeholder = 'MM/DD/YYYY',
  onTimeChange,
  startDate,
  endDate,
  error = false
}) => {
  // const disabled = useMemo(() => isDisabled, []);
  const onDayPickerChange = (time: Date) => {
    onTimeChange(time);
  };

  const onTimePickerChange = (time: Date) => {
    const isDate = time instanceof Date;

    if (!isDate) {
      return;
    }

    const hours = time?.getHours();
    const minutes = time?.getMinutes();
    const isValidHour = hours > -1 && hours < 24;
    const isValidMinute = minutes > -1 && minutes < 60;

    if (isValidHour && isValidMinute) {
      onDayPickerChange(time);
    }
  };

  const filterTimeFrom = (from: Date) => (time: Date | number): boolean => {
    if (!from) {
      from = new Date();
    }
    const selectedDate = new Date(time);

    return from.getTime() < selectedDate.getTime();
  };

  return (
    <div className={'date-picker-container'}>
      <h6>{title}</h6>
      <div className={'date-pickers'}>
        <Suspense fallback={<span className="spinner" />}>
          <LazyDatePicker
            className={classNames('date-picker', error && 'time-error')}
            popperClassName={'date-picker-tooltip'}
            selected={time}
            // disabled={disabled}
            minDate={startDate}
            maxDate={endDate}
            onChange={onDayPickerChange}
            placeholderText={placeholder}
            dateFormat="MM/dd/yyyy"
            popperModifiers={{
              preventOverflow: {
                enabled: true,
                escapeWithReference: false
              }
            }}
          />
          <LazyDatePicker
            className={classNames('time-picker', error && 'time-error')}
            popperClassName={'date-picker-tooltip'}
            selected={time}
            // disabled={disabled}
            onChange={onTimePickerChange}
            filterTime={filterTimeFrom(startDate)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={30}
            timeCaption="Time"
            placeholderText={'HH:MM PM'}
            dateFormat="h:mm aa"
            popperModifiers={{
              preventOverflow: {
                enabled: true,
                escapeWithReference: false
              }
            }}
          />
        </Suspense>
      </div>
    </div>
  );
};

export default DatePicker;
